import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IRegisRulesDocInitialState, IRegisRulesDocPayload } from "../types";

const initialState: IRegisRulesDocInitialState = {
    regisRulesDoc: [],
    selectedRegisRulesDocIDs: [],
    isLoadingRegisRulesDoc: true,
    isViewRestoreRegisRulesDoc: false,
    restoreRegisRulesDoc: [],
};

const regDocsRulesSlice = createSlice({
    name: "registrationDocsRules",
    initialState,
    reducers: {
        setRegisRulesDoc: (state, action) => {
            state.regisRulesDoc = action.payload;
        },
        setIsViewRestoreRegisRulesDoc: state => {
            state.isViewRestoreRegisRulesDoc = !state.isViewRestoreRegisRulesDoc;
        },
        deletedRestoreRegisRulesDoc: (state, action) => {
            state.restoreRegisRulesDoc = state.restoreRegisRulesDoc.filter(elem => elem.id !== action.payload);
        },

        deleteRegisRulesDoc: (state, action: PayloadAction<number>) => {
            const id = action.payload;
            state.regisRulesDoc = state.regisRulesDoc.filter(elem => elem.id !== id);
        },
        updateRegisRulesDoc: (state, action) => {
            const updateData = action.payload;
            state.regisRulesDoc = state.regisRulesDoc.map((elem: IRegisRulesDocPayload) => {
                if (elem.id === updateData.id) {
                    return {
                        ...elem,
                        ...updateData,
                    };
                }
                return elem;
            });
        },
        setSelectedRegisRulesDocIDs: (state, action) => {
            state.selectedRegisRulesDocIDs = action.payload;
        },
        setRegisRulesDocRestore: (state, action) => {
            state.restoreRegisRulesDoc = action.payload;
        },
    },
});

export const {
    setSelectedRegisRulesDocIDs,
    setIsViewRestoreRegisRulesDoc,
    deletedRestoreRegisRulesDoc,
    setRegisRulesDocRestore,
    updateRegisRulesDoc,
    deleteRegisRulesDoc,
    setRegisRulesDoc,
} = regDocsRulesSlice.actions;
export default regDocsRulesSlice;
